export function tourLightbox() {
  const signupModal         = document.getElementById('signup-modal');
  const closeBtn            = document.getElementById('close-lightbox');
  const toggleAllBtn        = document.getElementById('button_1_select_all');

  // 1. Example: We'll still be broad here; adjust as needed.
  //    If you still get duplicates, you can try:
  //    '#field_1_1 input.gfield-choice-input[type="checkbox"]'
  const checkboxes = document.querySelectorAll(
    '#gform_1 input[type="checkbox"][name^="input_1."]'
  );

  const selectedShowsField = document.getElementById('input_1_10');

  // --- MODAL FUNCTIONS ---
  function openModal() {
    signupModal.classList.remove('hidden');
  }
  function closeModal() {
    signupModal.classList.add('hidden');
  }

  // --- UPDATE SELECTED SHOWS ---
  function updateSelectedShows() {
    if (!selectedShowsField) return;

    // Collect unique checked values in a Set
    const uniqueValues = new Set();
    checkboxes.forEach(cb => {
      if (cb.checked) {
        uniqueValues.add(cb.value);
      }
    });

    const totalCount   = checkboxes.length;
    const checkedCount = uniqueValues.size;  // # of unique selections

    if (checkedCount === 0) {
      selectedShowsField.value = 'None';
    } else if (checkedCount === totalCount) {
      selectedShowsField.value = 'All';
    } else {
      selectedShowsField.value = Array.from(uniqueValues).join(', ');
    }
  }

  // --- PRE-CHECK CITY ---
  function preCheckCity(cityName) {
    const cityNameLower = cityName.trim().toLowerCase();
    checkboxes.forEach(checkbox => {
      const checkboxValue = checkbox.value.trim().toLowerCase();
      if (checkboxValue === cityNameLower) {
        checkbox.checked = true;
      } else {
        checkbox.checked = false;
      }
    });
    updateSelectedShows();
  }

  // --- EVENT LISTENERS ---
  // 1) Update on each checkbox change
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateSelectedShows);
  });

  // 2) Gravity Forms Select All / Deselect All
  if (toggleAllBtn) {
    toggleAllBtn.addEventListener('click', () => {
      setTimeout(updateSelectedShows, 50);
    });
  }

  // 3) Lightbox open
  const signupLinks = document.querySelectorAll('.open-signup');
  signupLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const cityName = link.getAttribute('data-l') || '';
      openModal();
      preCheckCity(cityName);
    });
  });

  // 4) Lightbox close
  closeBtn.addEventListener('click', closeModal);
  signupModal.addEventListener('click', e => {
    if (e.target === signupModal) {
      closeModal();
    }
  });

  // --- INIT ---
  updateSelectedShows(); // If anything is checked on load
}
